import { cloneDeep } from 'lodash'

const config = cloneDeep(window.Config)

export default config
